import { defineComponent as _defineComponent } from 'vue'
import LoanApplication from '@/models/LoanApplication';
import LoanApplicationStatusChip from '@/components/commons/LoanApplicationStatusChip.vue';
import {computed, getCurrentInstance} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VListLoanApplication',
  props: {
    loanApplications: null,
    showStatus: { type: Boolean, default: false },
    reportedApplicationId: { default: null },
    tilePadding: { default: '0px' },
    small: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { loanApplications: LoanApplication[], showStatus: boolean, reportedApplicationId: Nullable<number>, tilePadding: string, small: boolean }



const instance = getCurrentInstance();

const reportedApplication = computed<Nullable<number>>(
  () => props.loanApplications && props.reportedApplicationId
    ? props.loanApplications.findIndex(e => e.id === props.reportedApplicationId)
    : null
);

const getName = (loanApplication: LoanApplication): string => loanApplication.productName || loanApplication.name;

const backgroundColor = (loanApplication: LoanApplication, index?: number): string => {
  if (!loanApplication.isLoanApplicationAvailable) {
    return 'rgba(35, 45, 59, 0.02)';
  }
  return index === reportedApplication.value ? instance?.proxy.$vuetify.theme.currentTheme.success + '33' : 'initial';
};

return { __sfc: true,props, instance, reportedApplication, getName, backgroundColor, LoanApplicationStatusChip }
}

})